module.exports = __webpack_public_path__ + "img/delete1.fcacce85.svg";